import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./errorTooltip.scss";
import ErrorIcon from "assets/imgs/icons/errorIcon.svg";
import ErrorIconRed from "assets/imgs/icons/errorIconRed.svg";
import { useState, useEffect } from "react";

function ErrorTooltip({ text, errorVariant = "white" }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, [text]);
  return (
    <OverlayTrigger
      placement="top-start"
      defaultShow={true}
      show={show}
      rootClose={true}
      rootCloseEvent="click"
      trigger={["click", "hover"]}
      onToggle={() => setShow(!show)}
      overlay={
        <Tooltip show={true} id="tooltip-error">
          {text}
        </Tooltip>
      }
    >
      {errorVariant === "white" ? (
        <div className="d-inline">
          <img
            src={ErrorIcon}
            style={{
              height: "15px",
              width: "15px",
            }}
            alt=""
          />
        </div>
      ) : (
        <div className="d-inline">
          <img
            src={ErrorIconRed}
            style={{
              height: "15px",
              width: "15px",
            }}
            alt=""
          />
        </div>
      )}
    </OverlayTrigger>
  );
}

export default ErrorTooltip;
